import React from 'react';
import PropTypes from 'prop-types';
import { find } from 'lodash';
import { Form, Button } from 'react-bootstrap';

import * as nodeOps from '../../../api/Tasks/task-node-operations';
import * as sourceOps from '../../../api/Sources/source-operations';

import Task from '../../../modules/TaskClass';

import ConnParamCreateMapServerElementCheck from '../../atoms/ConnParamCreateMapServerElementCheck';
import ConnParamMapServerElementFields from '../../atoms/ConnParamMapServerElementFields';
import ConnParamRefreshLatencyField from '../../atoms/ConnParamRefreshLatencyField';
import ConnParamTemporalCheck from '../../atoms/ConnParamTemporalCheck';
import PageHeader from '../../atoms/PageHeader';
import TableListContainer from '../../containers/TableListContainer';
import Validation from '../../containers/Validation';
import Sources from '../../pages/Sources';

class ConnectionParameters extends React.Component {
  state = {
    selectedSourceId: '',
    showMapServerElementCheck: false,
    showMapServerElementTypes: false,
    showRefreshLatencyField: false,
    showSourceSelector: true
  };

  componentDidMount() {
    this.setInitialFormState();
  }

  selectSource = newSelectedSourceId => this.setState({ selectedSourceId: newSelectedSourceId });

  setInitialFormState = () => {
    const { task, selectedNodeId } = this.props;
    const selectedNode = find(task.nodes, ['id', selectedNodeId]) || {};
    const taskHelper = new Task(task);
    const isRoot = taskHelper.isRoot(selectedNode);
    const isLeaf = taskHelper.isLeaf(selectedNode);
    const showTemporal = !(isRoot || isLeaf);
    let showMapServerElementCheck = false;
    const showSourceSelector = !showTemporal || !nodeOps.isTemporal(selectedNode);
    const selectedSourceId = sourceOps.getId(nodeOps.getSource(selectedNode));
    if (nodeOps.isNodeReady(selectedNode)) {
      if (nodeOps.isMapServerElementAllowed(selectedNode)) {
        showMapServerElementCheck = true;
      }
      if (nodeOps.isTemporal(selectedNode)) {
        showMapServerElementCheck = false;
      }
      this.setState({
        showMapServerElementCheck,
        showMapServerElementTypes: nodeOps.shouldCreateMapServerElement(selectedNode),
        showRefreshLatencyField:
          nodeOps.shouldCreateMapServerElement(selectedNode) &&
          !nodeOps.shouldMapServerElementAutoRefresh(selectedNode),
        showSourceSelector,
        selectedSourceId
      });
    } else {
      if (!showTemporal) {
        showMapServerElementCheck = !isRoot;
        if (isRoot && isLeaf) {
          showMapServerElementCheck = nodeOps.isMapServerElementAllowed(selectedNode);
        }
      } else {
        showMapServerElementCheck = nodeOps.isMapServerElementAllowed(selectedNode);
      }
      this.setState({
        showMapServerElementCheck,
        showSourceSelector,
        selectedSourceId
      });
    }
  };

  showMapServerElement = event => {
    const isTemporal = event.target.checked;
    if (isTemporal) {
      this.setState({
        showRefreshLatencyField: false,
        showMapServerElementTypes: false
      });
    }
    this.setState({
      showMapServerElementCheck: !isTemporal,
      showSourceSelector: !isTemporal
    });
  };

  showRefreshLatencyField = event => {
    const shouldAutorefresh = event.target.form.autorefresh.checked;
    this.setState({ showRefreshLatencyField: !shouldAutorefresh });
  };

  showTypes = event => {
    const creteMapServerElement = event.target.checked;
    if (!creteMapServerElement) {
      this.setState({ showRefreshLatencyField: false });
    } else {
      this.setState({ showRefreshLatencyField: true });
    }
    this.setState({ showMapServerElementTypes: creteMapServerElement });
  };

  render() {
    const { myConfig, task, selectedNodeId, close, saveConnectionParams } = this.props;
    const {
      selectedSourceId,
      showMapServerElementCheck,
      showMapServerElementTypes,
      showRefreshLatencyField,
      showSourceSelector
    } = this.state;
    const selectedNode = find(task.nodes, ['id', selectedNodeId]);

    if (!nodeOps.isConnection(selectedNode)) {
      return null;
    }

    const taskHelper = new Task(task);
    const isRoot = taskHelper.isRoot(selectedNode);
    const isLeaf = taskHelper.isLeaf(selectedNode);
    const showTemporal = !(isRoot || isLeaf);

    const validationProps = {
      rules: {
        source: {
          required: showSourceSelector
        },
        mapServerElementType: {
          required() {
            return '#createMapServerElement:checked';
          }
        },
        refreshLatency: {
          required: false,
          min: 1
        }
      },
      messages: {
        source: {
          required: 'Please select a source'
        },
        mapServerElementType: {
          required: 'Please select a layer server type'
        },
        refreshLatency: {
          min: 'This time cannot be lower than 1 minute'
        }
      },
      submitHandler: form => {
        saveConnectionParams(form, selectedSourceId);
      }
    };

    return (
      <>
        <PageHeader>
          <h5>{nodeOps.getLabel(selectedNode)}</h5>
        </PageHeader>
        <Validation {...validationProps}>
          <Form onSubmit={event => event.preventDefault()} id={nodeOps.getId(selectedNode)}>
            <TableListContainer
              Page={props => (
                <Sources
                  height={myConfig.height}
                  isPremium
                  isTasker
                  selectedSourceId={selectedSourceId}
                  handleSelectRow={this.selectSource}
                  {...props}
                />
              )}
            />
            <ConnParamTemporalCheck
              showTemporal={showTemporal}
              selectedNode={selectedNode}
              updateFieldsToShow={this.showMapServerElement}
            />
            <ConnParamCreateMapServerElementCheck
              selectedNode={selectedNode}
              showMapServerElementCheck={showMapServerElementCheck}
              updateFieldsToShow={this.showTypes}
            />
            <ConnParamMapServerElementFields
              selectedNode={selectedNode}
              showMapServerElementTypes={showMapServerElementTypes}
              updateFieldsToShow={this.showRefreshLatencyField}
            />
            <ConnParamRefreshLatencyField
              selectedNode={selectedNode}
              showRefreshLatencyField={showRefreshLatencyField}
            />
            <br />
            <div className="d-flex flex-row justify-content-end">
              <Button variant="danger" onClick={close}>
                Cancel
              </Button>
              <Button type="submit" variant="success">
                Save Changes
              </Button>
            </div>
          </Form>
        </Validation>
      </>
    );
  }
}

ConnectionParameters.propTypes = {
  myConfig: PropTypes.object.isRequired,
  selectedNodeId: PropTypes.string.isRequired,
  task: PropTypes.object.isRequired,
  close: PropTypes.func.isRequired,
  saveConnectionParams: PropTypes.func.isRequired
};

export default ConnectionParameters;
